import React from 'react';
import { Link } from 'react-router-dom';
import { UserShape } from '../shapes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';

export default class HeaderMenu extends React.Component {
  static propTypes = {
    user: UserShape,
    onLogout: PropTypes.func
  }

  state = {
    showMenu: false
  }

  render() {
    if (this.state.showMenu) {
      return this.renderMenuOpen();
    } else {
      return this.renderMenuClosed();
    }
  }

  renderMenuOpen() {
    const followText = (this.props.user.get('followsCount') > 0) ? 'follow more people' : 'follow people'
    return (
      <div className='header-menu'>
        <a href='#' onClick={ e => this.closeMenu(e) }>
          <FontAwesomeIcon icon={ faBars } className='regular' size='lg' />
        </a>
        <ul className='header-menu-items' ref={ (element) => this.dropdownMenu = element }>
          <li><Link to='/account/points_board'>points board ({ `${ this.props.user.get('points').toLocaleString() })` }</Link></li>
          <li><Link to='/account/recommend_people_to_follow'>{ followText }</Link></li>
          <li className='separator'></li>
          <li><Link to='/account'>account</Link></li>
          <li><Link to='/account/notification_preferences'>notification settings</Link></li>
          <li><Link className='logout' to={ '#' } onClick={ (e) => this.onLogout(e) }>log out</Link></li>
          <li className='separator'></li>
          <li><a href='https://yaktack.substack.com/' rel='noopener noreferrer' target='_blank'>newsletter</a></li>
        </ul>
      </div>
    )
  }

  renderMenuClosed() {
    return (
      <div className='header-menu'>
        <a href='#' onClick={ e => this.showMenu(e) }>
          <FontAwesomeIcon icon={ faBars } className='regular' size='lg' />
        </a>
      </div>
    )
  }

  showMenu = (e) => {
    e.preventDefault();
    this.setState({ showMenu: true }, () => {
      document.addEventListener('click', this.closeMenu);
    });
  }

  closeMenu = () => {
    this.setState({ showMenu: false }, () => {
      document.removeEventListener('click', this.closeMenu);
    });
  }

  onLogout(e) {
    e.preventDefault();
    this.props.onLogout();
  }
}



// WEBPACK FOOTER //
// ./src/components/header_menu.jsx